import {ICommonComponentEditorProps} from "components/ComponentType";
import Editor from "@monaco-editor/react";
import {TabPanel, TabView} from "primereact/tabview";
import React, {useEffect, useState} from "react";

const FreeTextDefaultConfig = {
    content: ""
};

interface FreeTextConfig {
    content: string;
}

const FreeTextEditor = ({config, onConfigChange}: ICommonComponentEditorProps) => {
    let conf: FreeTextConfig = config ?? FreeTextDefaultConfig;

    if (Object.keys(conf).length === 0) {
        conf = FreeTextDefaultConfig;
    }

    const [value, setValue] = useState(conf.content);

    const handleHTMLEditorChange = (e: any) => {
        setValue(e);
    }

    useEffect(() => {
        onConfigChange({content: value});
    }, [value]);

    return (
        <TabView activeIndex={0}>
            <TabPanel header="Add raw HTML">
                <Editor   height="420px"
                          defaultLanguage="html"
                          value={config.content}
                          onChange={handleHTMLEditorChange}
                          theme="vs-dark"
                            options={{
                                minimap: {
                                    enabled: false
                                },
                                fontSize: 14,
                                wordWrap: "on",
                                wrappingIndent: "indent",
                                wrappingStrategy: "advanced",
                                formatOnType: true,
                                formatOnPaste: true,
                                snippetSuggestions: "inline",
                                tabCompletion: "on"
                            }}
                />
            </TabPanel>
        </TabView>
    );
};

export default FreeTextEditor;